import { CircularSpinnerß } from '@otter-ai/den-components';
import Uploady from '@rpldy/uploady';
import { useEffect, useState } from 'react';
import { useCreateSpeechUpload } from './hooks/helperHooks';
import { importAttemptedEvent, limitedImportsEvent } from './tracking/tracking';
import type {
  ImportQuotas,
  UploadItem,
  UploadModalContextData,
} from './types/types';
import { Upload } from './Upload';
import { extractUploadQuotas } from './utils/utils';

export function UploadRoot({
  updateUploadItems,
  setAbortFunction,
  contextData,
}: {
  updateUploadItems: (items: UploadItem[]) => void;
  setAbortFunction: (abortFn: (items: UploadItem[]) => void) => void;
  contextData: UploadModalContextData;
}) {
  const { refetch } = useCreateSpeechUpload();
  const [importQuota, setImportQuota] = useState<ImportQuotas | null>(null);

  useEffect(() => {
    // Fetch import quota data on mount
    const fetchData = async () => {
      const { data, error } = await refetch();
      const quota = extractUploadQuotas(data, error);
      setImportQuota(quota);
      limitedImportsEvent(quota);
    };

    fetchData();
    importAttemptedEvent();
  }, []);

  return (
    <Uploady multiple maxConcurrent={1} concurrent={false}>
      {importQuota ? (
        <Upload
          quota={importQuota}
          setImportQuota={setImportQuota}
          updateUploadItems={updateUploadItems}
          setAbortFunction={setAbortFunction}
          contextData={contextData}
        />
      ) : (
        <div className="flex justify-center items-center h-full">
          <CircularSpinnerß data-testid="upload-files-loader" />
        </div>
      )}
    </Uploady>
  );
}
